import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

import * as values from '../../../values'
import * as data from '../../data'

export const DOC = gql`
  ${data.fragments.valueTypeForAttribute.DOC}
  ${values.fragments.constraints.DOC}
  fragment FragmentDmsAttribute on DmsAttribute {
    id
    name
    description
    terms {
      id
    }
    note

    type {
      ...FragmentDmsValueTypeForAttribute
    }
    default
    computation
    constraints {
      ...FragmentValueConstraints
    }
    isOptional
    canBeOptional
    scoring {
      default
      lookup {
        key
        value
      }
    }
  }
`

/**
 * Transformer for the {@link graphql.schema.FragmentDmsAttributeFragment} to the
 * {@link ents.core.dms.models.Attribute}.
 */
export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentDmsAttributeFragment,
  ents.core.dms.models.Attribute
>({
  canBeOptional: graphql.transformers.OUT.default(
    transformers.PASS_THROUGH,
    // Default to `false` since that is safer. If we don't know, we'd rather
    // assume we can't make it optional
    false, // TODO: maybe default to isOptional
  ),
  computation: graphql.transformers.OUT.custom<
    graphql.schema.FragmentDmsAttributeFragment['computation'],
    ents.core.dms.models.Attribute['computation']
  >(computation => {
    const parsedComputation =
      typeof computation === 'string'
        ? graphql.transformers.OUT.json().getEntityFrom(computation)
        : computation
    return ents.core.dms.models.Attribute.Computation.isComputation(
      parsedComputation,
    )
      ? parsedComputation
      : undefined
  }),
  constraints: values.fragments.constraints.TRANSFORMER,
  default: transformers.PASS_THROUGH,
  description: transformers.PASS_THROUGH,
  id: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    ents.core.dms.models.Attribute.Id.isId,
    { warnOnly: true },
  ),
  isOptional: graphql.transformers.OUT.default(transformers.PASS_THROUGH, true),
  name: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    TypeChecker.isNotNullish,
    { warnOnly: true },
  ),
  note: transformers.PASS_THROUGH,
  scoring: graphql.transformers.OUT.object({
    default: graphql.transformers.OUT.validate(
      transformers.PASS_THROUGH,
      TypeAsserter.assertIsNotNullish,
      { warnOnly: true },
    ),
    lookup: graphql.transformers.OUT.record(
      graphql.transformers.OUT.tuple([
        graphql.transformers.OUT.nonNull(
          graphql.transformers.OUT.select(
            'key',
            graphql.transformers.OUT.validate(
              transformers.PASS_THROUGH,
              TypeAsserter.assertIsString,
              { warnOnly: true },
            ),
          ),
        ),
        graphql.transformers.OUT.nonNull(
          graphql.transformers.OUT.select(
            'value',
            graphql.transformers.OUT.validate(
              transformers.PASS_THROUGH,
              TypeAsserter.assertIsNumber,
              { warnOnly: true },
            ),
          ),
        ),
      ] as const),
    ),
  }),
  terms: () => undefined,
  type: graphql.transformers.OUT.validate(
    data.fragments.valueTypeForAttribute.TRANSFORMER,
    TypeChecker.isNotNullish,
    { warnOnly: true },
  ),
})
